import * as React from "react";
import { Link } from "react-router-dom";
import { Viewport, ViewMedium, ViewLarge, ViewSmall } from "bernie-view";
import { UitkCardAloha, UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
import { inject, observer } from "mobx-react";

export interface NotificationBannerBEXProps {
  heading: string | undefined;
  message: string;
  linkText: string | undefined;
  dialogQuery: string | undefined;
  onClickEvent: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export const NotificationBannerBEX = inject("routeStore")(
  observer((props: NotificationBannerBEXProps) => {
    const { heading, message, onClickEvent, dialogQuery, linkText } = props;
    const smallViewportSizeClassName = `
      bex-travel-advisory-with-chatbot-link
      uitk-flat-border-top
      uitk-flat-border-bottom
      all-x-padding-three
      all-y-padding-three
    `;
    const mediumViewportSizeClassName = "bex-travel-advisory-with-chatbot-link";
    const largeViewportSizeClassName = "bex-travel-advisory-with-chatbot-link";

    const renderHeadingAndMessage = () => (
      <>
        <UitkText inline={true} weight="bold">
          {heading}
        </UitkText>{" "}
        <UitkText inline={true}>{message}</UitkText>{" "}
      </>
    );

    const renderMobileContent = () => (
      <UitkCardAlohaContentSection className="uitk-type-center">
        <UitkText align="left" size={300}>
          {renderHeadingAndMessage()}
        </UitkText>
        <UitkText align="left" size={300} className="all-t-padding-three">
          <UitkLink onClick={onClickEvent} inline={true} className={"link"}>
            <Link role="button" to={{ search: dialogQuery }}>
              {linkText}
            </Link>
          </UitkLink>
        </UitkText>
      </UitkCardAlohaContentSection>
    );

    const renderDesktopContent = () => (
      <UitkCardAlohaContentSection className="uitk-type-center">
        <UitkText align="center" size={300}>
          {renderHeadingAndMessage()}
          <UitkLink onClick={onClickEvent} inline={true} className="link">
            <Link role="button" to={{ search: dialogQuery }}>
              {linkText}
            </Link>
          </UitkLink>
        </UitkText>
      </UitkCardAlohaContentSection>
    );

    return (
      <Viewport>
        <ViewSmall>
          <UitkCardAloha border={false} className={smallViewportSizeClassName}>
            {renderMobileContent()}
          </UitkCardAloha>
        </ViewSmall>
        <ViewMedium>
          <UitkCardAloha border={false} className={mediumViewportSizeClassName}>
            {renderMobileContent()}
          </UitkCardAloha>
        </ViewMedium>
        <ViewLarge>
          <UitkCardAloha border={false} className={largeViewportSizeClassName}>
            {renderDesktopContent()}
          </UitkCardAloha>
        </ViewLarge>
      </Viewport>
    );
  })
);
